import { z } from "zod"

import {
  fieldProjectionV11Schema,
  fieldVisitProjectionV11Schema,
} from "./field-projection-v11.js"
import { entityIdSchema } from "./identifiers.js"

export const fieldVisitCompletionProjectionV1Schema = z.object({
  completionId: entityIdSchema,
  completionVersion: z.number().int().positive(),
  reopenEligibleUntil: z.iso.datetime({ offset: true }),
  reopenState: z.enum(["Reopened", "Awaiting Review"]).nullable(),
}).strict()

export const fieldVisitProjectionV12Schema = z.object({
  ...fieldVisitProjectionV11Schema.shape,
  completion: fieldVisitCompletionProjectionV1Schema.nullable().default(null),
}).strict()

export const fieldProjectionV12Schema = z.object({
  ...fieldProjectionV11Schema.shape,
  responseVersion: z.literal(12),
  visits: z.array(fieldVisitProjectionV12Schema).max(100),
}).strict()

export type FieldProjectionV12 = z.infer<typeof fieldProjectionV12Schema>
export type FieldVisitProjectionV12 = z.infer<
  typeof fieldVisitProjectionV12Schema
>
